import { CONSTANTS, GRAPH_TYPES } from "../../../../constants/app-constant";
import { getLineGraphFormat } from "../../../Dashboard/data_formatter/format-utils";
const { AREA, GENDER } = GRAPH_TYPES;

export const formatDataByAuthorFollwingSocial = (
  d = [],
  isLineGraph,
  selectedInlineGraphType
) => {
  try {
    const graph_data = d.graph_data || [];
    
    const listOfEntities = graph_data.map((gd) => gd.topic_name);
    const labels = isLineGraph
      ? getLineGraphFormat(listOfEntities, true)
      : listOfEntities;
    if (selectedInlineGraphType === GENDER) {
      return {
        mValue: 40,
        fValue: 60,
      };
    }
    // const datasets = tonalities.map((tonality, index) => {
      const datasets = []
      graph_data.forEach((topic) => {
        let tmpArr = topic.post_data.sort((a, b) => {
          return b.following_count - a.following_count;
        });
        const topicPost = tmpArr.filter(
          (pc,pcIndex) => pcIndex <= 10
        );
        let returnData = topicPost.map((tempArr) => {
          const tempColor = Math.floor(Math.random()*16777215).toString(16);
          const toneColor =
            selectedInlineGraphType === AREA && typeof window.Color === "function"
              ? window.Color(tempColor).alpha(0.5).rgbString()
              : tempColor;

            datasets.push({
            data: [isLineGraph ? getLineGraphFormat(tempArr.following_count) : tempArr.following_count],
            label: tempArr.profile_name,
            backgroundColor: toneColor,
            borderColor: toneColor,
            fill: selectedInlineGraphType === AREA ? "start" : false,
            lineTension: 0,
          });
        })  
      });
      
    // });
    return {
      datasets,
      labels,
    };
  } catch (e) {
    return {
      datasets: [],
      labels: [],
    };
  }
};
